// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7385cd3c","239":"113ff032","455":"52c18c8b"}[chunkId] + ".chunk.js";
};